import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { useSessionLanguage } from '@context/SessionSettingsContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { TestAnswersDto } from '@model/ClientTestAnswerDto'
import { TickmillProductType } from '@model/TickmillProductType'

interface ProductAppropriatenessTestStatus {
  apTestAnswers?: TestAnswersDto
  attempt?: number
  isLoading: boolean
}

export const useProductAppropriatenessTestStatus = (
  productId: TickmillProductType
): ProductAppropriatenessTestStatus => {
  const locale = useSessionLanguage()
  const apiClient = useApiClient(ClientApiClient)

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.productRegistration.appTestStatus(locale, productId),
    queryFn: async () => {
      const [apTestAnswers, attempt] = await Promise.all([
        apiClient
          .getAccountAppTestAnswers(locale, productId)
          .catch((): TestAnswersDto | undefined => undefined),
        apiClient.getApTestAttempts(productId),
      ])

      return { apTestAnswers, attempt }
    },
    enabled: !!locale,
  })

  return {
    apTestAnswers: data?.apTestAnswers,
    attempt: data?.attempt,
    isLoading,
  }
}
